import styled from "styled-components";
import { Heading1, SubHeading } from "../../../../../landing-pages/js/common/styled-components/styled-components";
import { breakpoints, device } from "../../../utils/responsive_utilities";
import { white, royal, codGrey, transparentBlack } from '../../../components/loggedout/shared-styles/Colors';
import { styledFont, fontQuicksand } from '../../../../../landing-pages/js/common/mixins/mixin';

export const ContainerWrapper = styled.div`
  width: 100%;
  height: 100%;
  background: ${white};
  ${styledFont("Graphie")}
  padding: 3rem 1.6rem;
  box-sizing: border-box;
`;

export const Wrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column-reverse;
  justify-content: flex-end;
  /* align-items: center; */

  @media ${device.Desktop}, ${device.TabletLandscape}{
    flex-direction: row-reverse;
  }
`;

export const FeaturesWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  align-items: center;
  width: 100%;
  margin: auto;
  width: 34.1rem;

  @media (min-width: ${breakpoints.lg}px) {
    /* flex: 1; */
    align-items: flex-start;
    padding-right: 10.6rem;
    width: 46.8rem;
  }
  @media ${device.TabletLandscape}{
    padding-right: 0;
    width: 38.7rem;
    box-sizing: border-box;
  }
  @media ${device.Tablet}{
    width: 46.8rem;
  }
  @media ${device.PhoneTabletLandscape}{
    width: 55.6rem;
  }
`;
export const HeadingText = styled.h2`
  width: auto;
  color: ${codGrey};
  padding-top: 3rem;
  ${styledFont("Graphie", 2.8, 3.2, 7)};
  text-align: left;
  margin: 0;
  @media (min-width: ${breakpoints.lg}px) {
    ${styledFont("Graphie", 4, 4.8, 7)};
    width: 100%;
  }
  @media ${device.TabletLandscape}, ${device.Tablet}, ${device.PhoneTabletLandscape}{
    ${styledFont("Graphie", 3.2, 3.8, 7)};
  }
`;

export const SubHeadingText = styled(SubHeading)`
  width: 100%;
  color: ${royal};
  padding-top: 0.5rem;
  ${styledFont("Graphie", 2, 2.4, 6)}
  text-align: left;
  @media (min-width: ${breakpoints.sm}px) {
    width: auto;
  }
  @media (min-width: ${breakpoints.md}px) {
    width: auto;
  }
`;

export const ContentWrapper = styled.div`
  padding: 0 0 2.8rem;
  /* width: 34.1rem; */
  margin: 0;

  /* @media ${device.Desktop}, ${device.Tablet}{
    width: 46.8rem;
  }
  @media ${device.TabletLandscape}{
    width: 38.7rem;
  }
  @media ${device.PhoneTabletLandscape}{
    width: 55.6rem;
  } */
`;

export const Content = styled.p`
  ${styledFont("Graphie", 1.6, 2, 4)};
  margin-top: 1.6rem;
  @media ${device.Desktop}, ${device.TabletLandscape}, ${device.Tablet}, ${device.PhoneTabletLandscape}{
    ${styledFont("Graphie", 2, 2.8, 4)};
  }
`

export const ImageWrapper = styled.div`
  width: 26.7rem;
  height: 22.5rem;
  position: relative;
  margin: auto;
  & > img{
    height: 100%;
    width: 100%;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
  }
  @media (min-width: ${breakpoints.lg}px) {
    /* flex: 2; */
    width: 80.5rem;
    height: 55.3rem;
    margin-top: 4.9rem;
  }
  @media ${device.TabletLandscape}{
    width: 58.4rem;
    height: 40rem;
  }
  @media ${device.Tablet}{
    width: 76rem;
    height: 52.8rem; 
  }
  @media ${device.PhoneTabletLandscape}{
    width: 32rem;
    height: 18rem;
  }
`;

export const BtnWrapper = styled.div`
  margin-top: 4.5rem;
  width: 100%;
  > div{
    width: 25.2rem;
    margin: auto;
  }
  @media ${device.Desktop}{
    margin-top: 6.5rem;
  }
`
